import Document from "../general/document";

export interface LocationData {
  VVLOCATIE: string;
}

class Location extends Document<LocationData> {
  get title() {
    return this.data.VVLOCATIE;
  }
}

export default Location;
